import { BRAND_LEGAL_NAME, BRAND_SHORT_NAME } from './brand.js';

const siteUrlRaw =
  import.meta.env.VITE_SITE_URL?.trim() ||
  (typeof window !== 'undefined' ? window.location.origin : '') ||
  '';

export const SITE_URL = siteUrlRaw.replace(/\/$/, '');

export const SEO_DEFAULTS = {
  siteName: BRAND_SHORT_NAME,
  legalName: BRAND_LEGAL_NAME,
  locale: 'es_CO',
  defaultTitle: `${BRAND_SHORT_NAME} | ${BRAND_LEGAL_NAME}`,
  defaultDescription:
    'Portal oficial de Coonaltragas: noticias para asociados, líneas de crédito, convenios, sedes vacacionales en Tocaima, normatividad, PQRS y contacto en Bogotá.',
  defaultKeywords:
    'Coonaltragas, cooperativa, créditos, convenios, sedes vacacionales, Tocaima, asociados, economía solidaria, Bogotá',
  ogImagePath: '/logo.png',
  twitterCard: 'summary_large_image',
};

/** Rutas públicas indexables (sin admin). */
export const PUBLIC_ROUTE_SEO = [
  {
    path: '/',
    title: 'Inicio',
    description:
      'Cooperativa Nacional Multiactiva Grupo Asociativo Coonaltragas: servicios financieros, bienestar, créditos, convenios y sedes vacacionales para asociados.',
  },
  {
    path: '/nosotros',
    title: 'Quiénes somos',
    description:
      'Conoce la historia, misión, visión y objetivos de Coonaltragas, cooperativa multiactiva al servicio de sus asociados.',
  },
  {
    path: '/entes-administrativos',
    title: 'Entes administrativos',
    description:
      'Órganos de administración, consejo de administración, comités y dirección ejecutiva de Coonaltragas.',
  },
  {
    path: '/normatividad',
    title: 'Normatividad',
    description:
      'Documentos de asamblea, estatutos y reglamentos institucionales de la cooperativa Coonaltragas.',
  },
  {
    path: '/contacto',
    title: 'Contacto y PQRS',
    description:
      'Formulario de peticiones, quejas, reclamos y sugerencias. Ubicación en Bogotá, teléfono, correo y WhatsApp.',
  },
  {
    path: '/noticias',
    title: 'Noticias',
    description: 'Noticias y comunicados para asociados de Coonaltragas.',
  },
  {
    path: '/noticias/:id',
    title: 'Noticia',
    description: 'Detalle de noticia para asociados de Coonaltragas.',
  },
  {
    path: '/creditos',
    title: 'Créditos',
    description: 'Líneas de crédito disponibles para asociados de Coonaltragas. Condiciones y asesoría.',
  },
  {
    path: '/creditos/simulador',
    title: 'Simulador de crédito',
    description: 'Simula cuotas estimadas de crédito según monto, plazo e interés en Coonaltragas.',
  },
  {
    path: '/creditos/:id',
    title: 'Línea de crédito',
    description: 'Detalle de línea de crédito Coonaltragas: condiciones, tasas y documentación.',
  },
  {
    path: '/sedes-vacacionales',
    title: 'Sedes vacacionales',
    description:
      'Sede vacacional y casas en Tocaima, Cundinamarca. Tarifas, reglamento y reservas para asociados.',
  },
  {
    path: '/sedes-vacacionales/:id',
    title: 'Sede vacacional',
    description: 'Detalle de sede vacacional Coonaltragas: galería, ubicación, tarifas y contacto.',
  },
  {
    path: '/convenios',
    title: 'Convenios',
    description:
      'Convenios vigentes en recreación, salud y seguridad para asociados de Coonaltragas.',
  },
  {
    path: '/emprendimientos',
    title: 'Emprendimientos',
    description:
      'Emprendimientos de asociados Coonaltragas: productos, servicios, contacto y portafolios.',
  },
];

export const ADMIN_ROUTE_PREFIX = '/admin';

/** Títulos del documento en rutas del panel (noindex). */
export const ADMIN_ROUTE_SEO = [
  { path: '/admin/login', title: 'Inicio de sesión' },
  { path: '/admin/dashboard', title: 'Panel general' },
  { path: '/admin/carrusel', title: 'Carrusel' },
  { path: '/admin/home-popup', title: 'Avisos emergentes (inicio)' },
  { path: '/admin/noticias', title: 'Noticias' },
  { path: '/admin/vacaciones', title: 'Sedes vacacionales' },
  { path: '/admin/creditos', title: 'Créditos' },
  { path: '/admin/convenios', title: 'Convenios' },
  { path: '/admin/emprendimientos', title: 'Emprendimientos' },
  { path: '/admin/normatividad', title: 'Normatividad' },
  { path: '/admin/normatividad/categorias', title: 'Categorías normatividad' },
  { path: '/admin/entes-administrativos', title: 'Entes administrativos' },
  { path: '/admin/contacto', title: 'Contacto / PQRS' },
  { path: '/admin/usuarios', title: 'Usuarios del sistema' },
  { path: '/admin/auditoria', title: 'Auditoría' },
];

export const SITEMAP_PATHS = PUBLIC_ROUTE_SEO.filter(
  (r) => !r.path.includes(':')
).map((r) => r.path);
